import { PropsWithChildren } from 'react';

const AuthPageWrapper = ({ children }: PropsWithChildren) => (
  <main className='relative w-full min-h-full h-fit max-w-[120rem] mx-auto flex flex-col ~gap-8/10 lg:flex-row items-center justify-center bg-secondary-50 dark:bg-secondary-dark-200 ~p-4/8 overflow-y-visible'>
    {children}
  </main>
);

export default AuthPageWrapper;
